import { useUserState } from "portal-ui-remote/UserStateContext";

import config from "config";

export interface ZapierRequestData {
  Date: string;
  ["Full name"]: string;
  ["Client name"]: string;
  ["Client ID"]: string;
  Email: string;
  ["Token migration help"]: boolean;
}

export const usePostZapierTokenMigration = ({
  migrationHelp,
}: {
  migrationHelp: boolean;
}) => {
  const { userState } = useUserState();

  const dataToPost: ZapierRequestData = {
    ["Date"]: new Date().toUTCString(),
    ["Full name"]: userState?.userName || "",
    ["Client name"]: userState?.clientName || "",
    ["Client ID"]: userState?.id || "",
    ["Email"]: userState?.email || "",
    ["Token migration help"]: migrationHelp,
  };

  const postFeed = async () => {
    return fetch(config.ZAPIER_TOKEN_MIGRATION_URL, {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(dataToPost),
    }).then((res) => {
      if (!res.ok) {
        throw res;
      }

      return res;
    });
  };

  return { postFeed };
};
